import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import CenterService from '../../../services/centers/center.service.js'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions.js'
import DataTableComp from '../../../components/common/data-table/DataTableComp.jsx'
import Modal from '../../../components/modal/Modal.jsx'
import useModal from '../../../utils/hooks/useModal.js'
import CenterComercialDataForm from './form/CenterComercialDataForm.tsx'
import { formatDate } from '../../../utils/helpers/format.js'
import { urlBack } from './utils/center.utils.ts'
import AppButton from '../../../component/common/AppButton.tsx'
import CenterSection from './common/CenterSection.tsx'
import AppModal from '../../../component/layout/AppModal.tsx'
import { useTranslation } from 'react-i18next'
import { useDisclosure } from '@mantine/hooks'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'

const CenterComercialData = () => {
  const { formatDate: formatDateInl } = useIntl()
  const { t } = useTranslation()

  const [opened, { open, close }] = useDisclosure(false)

  const { isShowing, toggle } = useModal()
  const { id } = useParams()

  const [currentCenter, setCurrentCenter] = useState()
  const [selectedRowId, setSelectedRowId] = useState()

  const navigate = useNavigate()

  useEffect(() => {
    getCenterData()
  }, [])

  useEffect(() => {
    if (!opened) dataFacade?.reload()
  }, [opened])

  const getCenterData = async () => {
    if (id && id !== 'undefined') {
      const response = await CenterService.getById(id)
      if (response) {
        setCurrentCenter(response.resp)
      }
    }
  }

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'comercialDataId',
    getAll: ({ filter, sort, limit, skip }) =>
      CenterService?.comercialData?.getAll({ id, filter, sort, limit, skip }),
  })

  const headerOptions = {
    title: currentCenter?.basicData?.name,
    // searchOptions: dataFacade?.searchOptions,
    handlerHeaderActions: {
      showBackButton: true,
      backButton: () => navigate(urlBack(currentCenter?.centerType)),

      secondaryButton: () => {
        setSelectedRowId()
        toggle()
      },
      secondaryButtonText: 'button.add',
      secondaryButtonIcon: 'pi-plus',
    },
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        value: dataFacade?.data?.resp,
        dataKey: '_id',
        editMode: 'row',
        selectionMode: 'single',
        selection: selectedRowId,
        onRowSelect: (e) => {
          setSelectedRowId(e?.data?._id)
          toggle()
        },
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column
          sortable
          field="date"
          header={t('date')}
          style={{ minWidth: '200px', width: '10%' }}
          body={({ date }) => formatDate({ date, formatDateInl })}
        />,
        <Column
          sortable
          field="name"
          header={t('name')}
          style={{ width: '60%' }}
        />,
        <Column sortable field="user.name" align="right" header={t('user')} />,
      ]}
    />
  )

  return (
    <CenterSection
      toolbar={[
        <AppToolbar
          rightSection={[
            <AppButton
              preset="back"
              onClick={() => navigate(urlBack(currentCenter?.centerType))}
            />,
            <AppButton
              preset="add"
              onClick={(e) => {
                setSelectedRowId(e?.data?._id)
                open()
              }}
            />,
          ]}
        />,
      ]}
    >
      {dataTable}
      <AppModal
        opened={opened}
        close={close}
        title={t('center.comercialData.add')}
      >
        <CenterComercialDataForm
          centerId={id}
          rowId={selectedRowId}
          close={close}
        />
      </AppModal>

      {/* <Modal
                isShowing={isShowing}
                hide={toggle}
                width="90%"
                maxWidth="650px"
                title={msg({ id: 'center.comercialData.add' })}
                context={(
                    <CenterComercialDataForm centerId={id} rowId={selectedRowId} hide={toggle} />
                )}
            /> */}
    </CenterSection>
  )
}

export default CenterComercialData
